<template>
  <portal to="root">
    <transition name="fade-trans">
      <div v-if="hovering"
        class="dropzone p-2 py-4"
        
        @dragstart="allowDrop"
        @dragover="allowDrop"
        @drop="drop"
      >
        <div class="dashed-wrapper d-flex flex-column justify-content-center align-items-center">
          <slot name="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </slot>
          <h2>
            <slot>
              Drop om uw bestanden te uploaden
            </slot>
          </h2>
        </div>
      </div>
    </transition>
  </portal>
</template>

<script>

export default {
  data() {
    return {
      hovering: false,
    }
  },
  mounted() {
    document.body.addEventListener("dragover", this.dragOver, {passive: true})
  },
  beforeDestroy() {
    document.body.removeEventListener("dragover", this.dragOver)
  },
  methods: {
    dragend() {
      this.hovering = false
    },
    dragOver(evt) {
      const item = evt && evt.dataTransfer && evt.dataTransfer.items && evt.dataTransfer.items[0]
      if (!item || (item && !item.type.includes("image/"))) return;
        
      if (this.timeout) clearTimeout(this.timeout)
      this.hovering = true

      this.timeout = setTimeout(() => this.hovering = false, 100)
      
      return true
    },
    allowDrop(evt) {
      evt.preventDefault()
      return true
    },
    drop(evt) {
      evt.preventDefault()
      if (!evt.dataTransfer) return;
      const files = evt.dataTransfer.files ? Array.from(evt.dataTransfer.files) : null
      if (!files || !files[0]) {
        return this.$error("Bestandsformaat niet beschikbaar")
      }

      this.$emit("upload", files)
    },
  },
}

</script>

<style scoped>

.dropzone {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 400;
  background-color: white;
  transition-duration: .15s;
}

.dashed-wrapper {
  border: 5px dashed rgba(0, 0, 0, 0.125);
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

svg {
  color: rgba(0, 0, 0, .3);
}

h2 {
  font-size: 1.25em;
}

</style>
